<template>
  <component :is="LayoutComponent">
    <slot />
  </component>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useLayout } from '@shared/layouts'

const route = useRoute()
const layout = ref(route?.meta?.layout || 'default')
const LayoutComponent = computed(() => useLayout(layout.value))

watch(route, (newRoute) => {
  layout.value = newRoute?.meta?.layout || 'default'
})
</script>
